import * as React from 'react';
import AuthContext from '../AuthContext.js';
import { isAuthenticated } from '../utils/utils.js';

/**
 * Auth State Hook
 *
 * @returns - Auth State Function
 */
function useAuthUser() {
    var context = React.useContext(AuthContext);
    if (context === null) {
        throw new Error('Auth Provider is missing. ' +
            'Please add the AuthProvider before Router');
    }
    return function () {
        if (isAuthenticated(context.authState)) {
            return context.authState.userState;
        }
        else {
            // TODO: Need to signout and redirect to login
            return null;
        }
    };
}

export { useAuthUser as default };
